import { FunctionComponent, ReactElement } from 'react';
import { useStoreMap } from 'effector-react';
import classNames from 'classnames';
import { useDraggable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';
import { MenuItemType, MenuType } from '@nx-frontend/shared/types';
import { getMenuItemParams } from './store-maps';

interface MenuTreeItemDraggableProps {
  id: string;
  menuType: MenuType;
  children: ReactElement;
  disabledDragItemTypes?: MenuItemType[];
}

const MenuTreeItemDraggableEnabled: FunctionComponent<MenuTreeItemDraggableProps> = ({ id, menuType, children }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: 'draggable-' + id,
    data: {
      originalId: id,
      menuType,
    },
  });

  const style = {
    transform: CSS.Transform.toString(transform ? { ...transform, scaleY: 1 } : transform),
  };

  return (
    <div
      ref={setNodeRef}
      style={{ ...style }}
      className={classNames('z-auto relative', {
        'z-[999] opacity-50': isDragging,
      })}
      {...listeners}
      {...attributes}
    >
      {children}
    </div>
  );
};

export const MenuTreeItemDraggable: FunctionComponent<MenuTreeItemDraggableProps> = (props) => {
  const { id, menuType, disabledDragItemTypes = [] } = props;
  const menuItem = useStoreMap(getMenuItemParams(id, menuType));

  if (disabledDragItemTypes.length && disabledDragItemTypes.includes(menuItem.type)) {
    return props.children;
  } else {
    return <MenuTreeItemDraggableEnabled {...props} />;
  }
};
